import HttpClient from "libs/utils/HttpClient";

class SurrogateService {


  async getSurrogate() {
    try {


      const response = await HttpClient.get(`/api/surrogate/list`);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async addSurrogate(body) {
    try {
      const response = await HttpClient.post(`/api/surrogate/add`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

}

export default new SurrogateService();

